export default "__VITE_ASSET__CrZSpfim__"